import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { getWelcomeScreenHtml } from './welcomeScreenConfig';
import { Box } from '@mui/material';
import useClientInteractiveReady from './useClientInteractiveReady';
/** Merchant-configured welcome HTML with native button-to-chat delegation. */
const WelcomeScreenHtml = ({ html, isLoading, append, fallback, }) => {
    const ready = useClientInteractiveReady();
    if (!ready || !getWelcomeScreenHtml(html))
        return _jsx(_Fragment, { children: fallback });
    return (_jsx(Box, { "data-mcn-welcome-html": "1", sx: {
            minWidth: 0,
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            // This flex child can be shorter than its content at browser zoom or low heights.
            // Keep vertical scrolling native; hidden overflow clips cards outside the parent's range.
            overflowX: 'hidden',
            overflowY: 'auto',
            isolation: 'isolate',
            '& button': { font: 'inherit', cursor: 'pointer' },
            '& button:disabled': { cursor: 'wait', opacity: 0.65 },
            '& button:focus-visible': { outline: '3px solid #74191C', outlineOffset: '-4px' },
            '& ul, & ol': { paddingInlineStart: '1.5rem', listStylePosition: 'outside' },
            '& li': { display: 'list-item' },
        }, onClick: (event) => {
            if (isLoading || !ready || !(event.target instanceof Element))
                return;
            const button = event.target.closest('button[type="button"]');
            if (!button || !event.currentTarget.contains(button))
                return;
            const label = button.cloneNode(true);
            label.querySelectorAll('[aria-hidden="true"]').forEach((element) => element.remove());
            const prompt = label.textContent?.replace(/\s+/g, ' ').trim();
            if (!prompt)
                return;
            append({
                role: 'user',
                content: `<SuggestedPrompt type="suggested" source="shopping_assistant">\n${prompt}\n</SuggestedPrompt>`,
            });
        }, dangerouslySetInnerHTML: { __html: html } }));
};
export default WelcomeScreenHtml;
//# sourceMappingURL=WelcomeScreenHtml.js.map